import {ExtractModalEmits, ExtractProps, ModalComponent, ModalInstance, ModalOptions} from '@/components/L/Modal/ModalTypes';
import {useModalStore} from '@/components/L/Modal/useModalStore';

export function useModal() {
  const store = useModalStore();

  async function openModal<T extends(ModalComponent)> (formComponent: T, props?: Partial<ExtractProps<T>>, modalOptions?: ModalOptions): Promise<ExtractModalEmits<T>> {
    const uuid = crypto.randomUUID();

    const modal: ModalInstance = {
      uuid,
      formComponent,
      props,
      modalOptions,
    };
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async(resolve) => {
      store.addModal(modal, (closePayload: unknown) => {
        resolve(closePayload)
      });
    })
  }

  return {
    openModal,
  };
}
